'use client';
import {cn} from '@/lib/utils';
import clsx from 'clsx';
import {useTranslations} from 'next-intl';
import {useState} from 'react';
import PageLayout from '../PageLayout';

export default function NotFoundPage() {
  const t = useTranslations('NotFoundPage');
  const [searchQuery, setSearchQuery] = useState('');

  const search = () => {
    if (searchQuery === '') {
      return;
    }
    window.location.href = '/search?q=' + searchQuery;
  };

  return (
    <PageLayout title={t('title')}>
      <div className="main-banner">
        <div className="relative">
          <div className="absolute left-0 h-full w-[100vw] text-white flex flex-col">
            <div className="h-[15vw] md:h-[6.2vw]"></div>
            <div className="flex justify-center items-center flex-1">
              <div>
                <h1 className="title text-center text-4xl mb-5 font-[700]">
                  {t('title')}
                </h1>
                <div className={clsx('title text-center text-xl font-[300]')}>
                  {t('description')}
                </div>
              </div>
            </div>
          </div>
          <img
            src="/assets/images/search/banner.png"
            alt={t('title')}
            className="w-full object-cover h-[55vh]"
          />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center my-[10vh] ">
        <div className="flex flex-col  ">
          <div className="flex justify-center  items-center gap-2 ">
            <div className="flex justify-center items-center border border-gray-200 rounded-md p-2">
              <div className="material-symbols outlined">search</div>
              <input
                type="text"
                placeholder={t('search')}
                className="md:w-[20vw] max-w-[400px] pl-2 text-[14px] py-2"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    search();
                  }
                }}
              />
            </div>
            <button
              className={cn(
                'w-10 h-10 rounded-full text-white flex justify-center items-center cursor-pointer hover:opacity-100',
                searchQuery === '' ? 'opacity-50' : 'opacity-90'
              )}
              style={{
                backgroundImage: "url('/assets/images/search/banner.png')",
                backgroundSize: 'cover'
              }}
              onClick={search}
            >
              <div className="material-symbols outlined">send</div>
            </button>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
